export enum CodeType {
  ModelName = 1,
  LicenseType = 2,
  ExpireDate = 3,
  ApplicationType = 4,
  ModelNameFree = 5,
  LicenseTypeFree = 6,
  VMSType = 7,
  ModelNameVOM = 8,
  LicenseTypeVOM = 9,
  adminContact = 10,
}
